/* eslint-disable react/no-danger */
import React from 'react'
import { string } from 'prop-types'

function CategoryBanner({ title = '', description = '' }) {
  const formattedText = (description).replace(/\n/g, '<br>')

  return (
    <div className="category-banner cgt-card cgt-card--inner-space is-rounded cgt-card--border">
      <div className="category-banner__container cgt-mt-0">
        <h1 className="cgt-legacy-heading-h4 category-banner__title">
          {title}
        </h1>
        <span
          className="category-banner__description cgt-mb-0"
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </div>
    </div>
  )
}

CategoryBanner.propTypes = {
  title: string,
  description: string,
}

export default CategoryBanner
